;(function () {
    $('.richtext table').wrap('<div class="scrollable-table"></div>');
})();
